export default [
  {
    path: '/app/download-logs',
    name: 'DownloadLogs',
    component: () => import('@/views/DownloadLogs/Index.vue'),
    meta: {
      pageTitle: 'İndirme Geçmişi',
      breadcrumb: [
        {
          text: 'Liste',
          active: true,
        },
      ],
      resource: 'ADMIN_DOWNLOAD_LOGS',
      action: 'read',
    },
  },
]
